import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Request::Steps::StepPreview />\n",{ moduleName: "client-portal/components/request/steps/message-step.hbs" })